import { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "react-hot-toast";

import NotFound from "./views/errors/404";
import Login from "./views/login";
import Reset from "./views/reset";
import Forgot from "./views/forgot";
import AlertFeedback from "./layout/alert-feedback";

import { LOGOUT } from "./actions/types";

import store from "./store";

const App = () => {
  useEffect(() => {
    // log user out from all tabs if they log out in one tab
    window.addEventListener("storage", () => {
      if (!localStorage.token) store.dispatch({ type: LOGOUT });
    });
  }, []);

  return (
    <HelmetProvider>
      <Provider store={store}>
        <Router forceRefresh>
          <AlertFeedback />
          <Toaster position="bottom-right" reverseOrder={false} />
          <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/reset/:token" component={Reset} />
            <Route exact path="/forgot" component={Forgot} />
            <Route path="*" component={NotFound} />
          </Switch>
        </Router>
      </Provider>
    </HelmetProvider>
  );
};

export default App;
